import { Component, HostBinding, inject, OnInit } from "@angular/core";
import { Auditor } from "@app/Domain/Models/auditor.model";
import { HttpLanguageService, HttpMenuService } from "@core/services";
import { AuditorService } from "@core/services/auditor.service";
import { LocalStorageService } from "@core/services/local-storage.service";
import { LocaleService } from "@core/services/locale.service";
import { SessionStorageService } from "@core/services/session-storage.service";
import { TopBarService } from "@core/services/top-bar-service";
import { LanguageComponent, LanguageModel, MenuService, UserAppModel } from "@iatec/nephos-layout";
import { TranslocoService } from "@jsverse/transloco";
import { forkJoin } from "rxjs";

@Component({
    selector: "app-main-template-topbar",
    imports: [LanguageComponent],
    templateUrl: "./topbar.component.html"
})
export class TopbarComponent implements OnInit {
    @HostBinding("class") class = `flex`;

    apps: UserAppModel[] = [];

    languages: LanguageModel[] = [];
    selectedLanguage: LanguageModel | undefined;
    auditor: Auditor;

    private _menuService = inject(MenuService);
    private _httpMenuService = inject(HttpMenuService);
    private _languageService = inject(HttpLanguageService);
    private sessionStorage = inject(SessionStorageService);
    private localStorageService = inject(LocalStorageService);
    private tranlocoService = inject(TranslocoService);
    private localeService = inject(LocaleService);
    private topBarService = inject(TopBarService);
    private auditorService = inject(AuditorService);

    isUserAdmin: boolean = this.auditorService.isAdm();
    isUserAuditor: boolean = !this.auditorService.isAdm() && !this.auditorService.isCoordenador();
    isUserCoordenador: boolean = this.auditorService.isCoordenador();

    ngOnInit(): void {
        this.auditor = this.sessionStorage.get("auditor");

        this._getDependencies();

        this.topBarService.menus$.subscribe((menus) => {
            if (menus.length > 0) this._menuService.menus = menus;
        });

        this.topBarService.languages$.subscribe((languages) => {
            if (languages.length > 0) {
                this.languages = languages;
                this.afterGetLanguages();
            }
        });
    }

    private _getDependencies() {
        forkJoin([
            this._httpMenuService.GetMenuPerfil(this.auditor.idPerfil, this.auditor.idPais),
            this._languageService.getLanguages()
            // this._appsService.getApps(),
        ]).subscribe(([menus, languages]) => {
            this._menuService.menus = menus;
            this.languages = languages;
            // this.apps = apps;

            this.afterGetLanguages();
        });
    }

    private afterGetLanguages(): void {
        //const lang = localStorage.getItem("lang") || "en-US";
        const lang = this.localStorageService.get("lang");

        this.tranlocoService.setAvailableLangs(this.languages.map((x) => `${x.code}-${x.country.code}`));

        this.selectedLanguage =
            this.languages.find((x) => x.code === lang?.split("-")[0] && x.country.code === lang?.split("-")[1]) ||
            this.languages[0];

        if (this.selectedLanguage) {
            let newLang = `${this.selectedLanguage.code}-${this.selectedLanguage.country.code}`;
            this.localStorageService.set("lang", newLang);
            this.tranlocoService.setActiveLang(newLang);

            this.localeService.registerCulture(newLang);
            this.tranlocoService.getTranslation(newLang);
        }
    }

    public afterChangeLanguage(language: LanguageModel | undefined): void {
        if (language) {
            const newLang = `${language.code}-${language.country.code}`;

            this.localStorageService.set("lang", newLang);
            this.tranlocoService.setActiveLang(newLang);

            this.localeService.registerCulture(newLang);
        }
    }
}
